import { render, staticRenderFns } from "./TaxableRebateSetupEdit.vue?vue&type=template&id=772d175a"
import script from "./TaxableRebateSetupEdit.vue?vue&type=script&lang=js"
export * from "./TaxableRebateSetupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports